// ----------------------------
// CAPTURE CS AGENT FROM URL
// ----------------------------
(function() {
  // Helper: Get URL parameter
  function getParam(param) {
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
  }

  // Helper: Read cookie
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // Capture CS agent from URL
  const agent = getParam('cs_agent');
  if (agent) {
    document.cookie = "cs_agent=" + agent + "; path=/; max-age=" + (3*24*60*60);
  }

  // Read saved agent value
  const savedAgent = getCookie('cs_agent');

  if (savedAgent) {
    // Fetch current cart to preserve any existing note
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const existingNote = cart.note || "";
        // Prepend CS agent to existing note
        const newNote = `CS Agent: ${savedAgent}` + (existingNote ? `\n${existingNote}` : "");

        // Update cart attributes + main note
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              cs_agent: savedAgent,
              site: "USA"
            },
            note: newNote
          })
        }).catch(() => {});
      });
  }
})();
